import { render, staticRenderFns } from "./FlightsList.vue?vue&type=template&id=e2c238c6"
import script from "./FlightsList.vue?vue&type=script&lang=js"
export * from "./FlightsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FlightsLoading: require('/home/forge/farescraper.com/components/FlightsLoading.vue').default,VerifiedResults: require('/home/forge/farescraper.com/components/VerifiedResults.vue').default,SponsoredResults: require('/home/forge/farescraper.com/components/SponsoredResults.vue').default})
